"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var ArrowIcon = function ArrowIcon(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#979797",
    d: "M0 1v35h2.43a1 1 0 0 0 .913-.593l7.562-16.987L3.347 1.59A1 1 0 0 0 2.435 1H0zm0-1h2.435a2 2 0 0 1 1.824 1.18L12 18.419 4.257 35.813A2 2 0 0 1 2.43 37H0V0z"
  }));
};

ArrowIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 12 37"
};

var ArrowIconActive = function ArrowIconActive(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("linearGradient", {
    id: "switcher-arrow-active_svg__a",
    x1: "50%",
    x2: "50%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/_react["default"].createElement("stop", {
    offset: "0%",
    stopColor: "#5BC9F5"
  }), /*#__PURE__*/_react["default"].createElement("stop", {
    offset: "100%",
    stopColor: "#2080F1"
  })), /*#__PURE__*/_react["default"].createElement("filter", {
    id: "switcher-arrow-active_svg__c",
    width: "108.3%",
    height: "102.7%",
    x: "-4.2%",
    y: "-1.4%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/_react["default"].createElement("feOffset", {
    dy: "1",
    "in": "SourceAlpha",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/_react["default"].createElement("feComposite", {
    "in": "shadowOffsetInner1",
    in2: "SourceAlpha",
    k2: "-1",
    k3: "1",
    operator: "arithmetic",
    result: "shadowInnerInner1"
  }), /*#__PURE__*/_react["default"].createElement("feColorMatrix", {
    "in": "shadowInnerInner1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  })), /*#__PURE__*/_react["default"].createElement("path", {
    id: "switcher-arrow-active_svg__b",
    d: "M617 2983h2.435a2 2 0 0 1 1.824 1.18l7.741 17.238-7.743 17.395a2 2 0 0 1-1.827 1.187H617v-37z"
  })), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-617 -2983)"
  }, /*#__PURE__*/_react["default"].createElement("use", {
    fill: "url(#switcher-arrow-active_svg__a)",
    xlinkHref: "#switcher-arrow-active_svg__b"
  }), /*#__PURE__*/_react["default"].createElement("use", {
    filter: "url(#switcher-arrow-active_svg__c)",
    xlinkHref: "#switcher-arrow-active_svg__b"
  })));
};

ArrowIconActive.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 12 37"
};

var SwitcherArrow = function SwitcherArrow(_ref) {
  var active = _ref.active,
      reverse = _ref.reverse;
  return /*#__PURE__*/_react["default"].createElement(StyledArrowContainer, {
    reverse: reverse
  }, /*#__PURE__*/_react["default"].createElement(StyledArrowWrapper, null, active ? /*#__PURE__*/_react["default"].createElement(StyledArrowActive, null) : /*#__PURE__*/_react["default"].createElement(StyledArrow, null)));
};

var StyledArrowContainer = _styledComponents["default"].div.withConfig({
  displayName: "SwitcherArrow__StyledArrowContainer",
  componentId: "sc-sqb5nf-0"
})(["position:absolute;height:100%;top:0;", ";", ";"], function (_ref2) {
  var reverse = _ref2.reverse;
  return !reverse && (0, _styledComponents.css)(["right:0;"]);
}, function (_ref3) {
  var reverse = _ref3.reverse;
  return reverse && (0, _styledComponents.css)(["left:0;transform:scaleX(-1);"]);
});

var iconStyles = (0, _styledComponents.css)(["position:absolute;top:0;left:-1px;height:100%;"]);

var StyledArrowWrapper = _styledComponents["default"].div.withConfig({
  displayName: "SwitcherArrow__StyledArrowWrapper",
  componentId: "sc-sqb5nf-1"
})(["position:relative;height:100%;"]);

var StyledArrow = (0, _styledComponents["default"])(ArrowIcon).withConfig({
  displayName: "SwitcherArrow__StyledArrow",
  componentId: "sc-sqb5nf-2"
})(["", ";"], iconStyles);
var StyledArrowActive = (0, _styledComponents["default"])(ArrowIconActive).withConfig({
  displayName: "SwitcherArrow__StyledArrowActive",
  componentId: "sc-sqb5nf-3"
})(["", ";"], iconStyles);
SwitcherArrow.propTypes = {
  active: _propTypes["default"].bool,
  reverse: _propTypes["default"].bool
};
SwitcherArrow.defaultProps = {
  active: false,
  reverse: false
};
var _default = SwitcherArrow;
exports["default"] = _default;